export default {
  "gameActions.title": "游戏操作",
  "gameActions.thead.actionId": "操作ID",
  "gameActions.thead.betOrderno": "投注订单号",
  "gameActions.thead.actionCode": "操作代码",
  "gameActions.thead.userNo": "会员ID",
  "gameActions.thead.email": "邮箱",
  "gameActions.thead.amount": "金额",
  "gameActions.thead.gameName": "游戏名称",
  "gameActions.thead.providerName": "提供商",
  "gameActions.thead.firstName": "名字",
  "gameActions.thead.lastName": "姓氏",
  "gameActions.thead.nickName": "昵称",
  "gameActions.thead.createTime": "创建时间",
  "gameActions.action.details": "详情",
  "gameActions.action.providerDetails": "提供商详情",
  "gameActions.tooltip.copy.userNo": "复制会员ID: {text}",
  "gameActions.tooltip.showUserDetails": "显示用户详情",
  "gameActions.tooltip.copy.betOrderno": "复制投注订单号: {text}",
  "gameActions.tooltip.copy.actionId": "复制操作ID: {text}",
  "gameActions.tooltip.copy.email": "复制邮箱: {text}",
  "gameActions.copy.success": "已复制到剪贴板",
};
